const adminCQERoles = [
  'Nexus-CQE-Admin-Dev',
  'Nexus-CQE-Admin-Prod',
  'Nexus-CQE-SuperAdmin-Dev',
  'Nexus-CQE-SuperAdmin-Prod',
]

export function getIsAdmin(userGroups: unknown) {
  if (!userGroups) return false
  
  // Handle different types of userGroups
  if (Array.isArray(userGroups)) {
    // If it's an array, check if any item in the array is in adminCQERoles
    return userGroups.some(group => 
      typeof group === 'string' && adminCQERoles.includes(group)
    )
  }
  
  // If it's not an array, convert to string and check
  const groupStr = String(userGroups)
  return adminCQERoles.includes(groupStr)
}
